import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const EMAIL_DEFAULT_SCHEMA = Object.freeze({
    CC: '',
    BCC: '',
    MESSAGE: '',
  }),
  RECORD = generateSchema(EMAIL_DEFAULT_SCHEMA),
  KEYS: any = generateKeys(EMAIL_DEFAULT_SCHEMA);

export class EmailDefault extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get message(): string {
    return this.get(KEYS.MESSAGE);
  }

  get cc(): string {
    return this.get(KEYS.CC);
  }

  get bcc(): string {
    return this.get(KEYS.BCC);
  }
}
